<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- 列表/表格切换 -->
        <RadioGroup v-model="dataTab" type="button" style="width: 150px;">
          <Radio label="列表"></Radio>
          <Radio label="图表" v-if="flatData"></Radio>
        </RadioGroup>
        <div class="label" style=" margin-left: 10px;width: 80px;">选择设备：</div>
        <Select v-model="deviceType" style="width: 250px; margin-left: 10px; text-align: center"
          @on-change="changeDeviceType" :disabled="defaultDeviceType != null">
          <Option :value="1">
            [气]1#炉脱硫脱硝除尘岛出口[{{ deviceStatus['1#'].status ? '正常' : '停运' }}]
          </Option>
          <Option :value="2">
            [气]2#炉脱硫脱硝除尘岛出口[{{ deviceStatus['2#'].status ? '正常' : '停运' }}]
          </Option>
          <Option :value="3">
            [气]3#炉脱硫脱硝除尘岛出口[{{ deviceStatus['3#'].status ? '正常' : '停运' }}]
          </Option>
          <Option :value="5">
            [水]污水出水[正常]
          </Option>
          <Option :value="6">
            [水]B区雨排口南[正常]
          </Option>
          <Option :value="7">
            [水]B区雨排口北[正常]
          </Option>
          <Option :value="8">
            [窖井]锅炉窖井[正常]
          </Option>
          <Option :value="9">
            [窖井]气化窖井[正常]
          </Option>
          <Option :value="10">
            [窖井]甲醇窖井[正常]
          </Option>
          <Option :value="11">
            [窖井]醋酸窖井[正常]
          </Option>
        </Select>
        <div class="label" style=" margin-left: 10px;width: 80px;">时间类型：</div>
        <RadioGroup v-model="timeType" type="button" @on-change="getNowTime" style="width: 200px;">
          <Radio label="天"></Radio>
          <Radio label="小时"></Radio>
          <Radio label="实时"></Radio>
        </RadioGroup>

        <DatePicker v-model="dateTimes.dateRange" type="daterange" placement="bottom-end" placeholder="选择日期"
          style="width: 200px; margin-left: 10px" @on-change="dateSelect($event)"></DatePicker>
        <div class="label" v-if="timeType != '天'" style="width: 80px;">小时范围：</div>


        <Select v-model="dateTimes.startTime" clearable style="width: 100px; margin-left: 10px; text-align: center"
          v-if="timeType == '小时'">
          <Option v-for="item in hourList" :key="item" :value="item">{{ item }}</Option>
        </Select>
        <span v-if="timeType == '小时'" style="margin-left: 10px;">-</span>
        <Select v-model="dateTimes.endTime" clearable style="width: 100px; margin-left: 10px; text-align: center"
          v-if="timeType == '小时'">
          <Option v-for="item in hourList" :key="item" :value="item">{{ item }}</Option>
        </Select>

        <TimePicker v-model="dateTimes.startTime" format="HH:mm" placeholder="选择时间"
          style="width: 100px; margin-left: 10px; text-align: center" v-if="timeType == '实时'" />
        <span v-if="timeType == '实时'">-</span>
        <TimePicker v-model="dateTimes.endTime" format="HH:mm" placeholder="选择时间"
          style="width: 100px; margin-left: 10px; text-align: center" v-if="timeType == '实时'" />
        <i-button type="default" @click="searchFunc" style="margin-left: 1em">搜索</i-button>
        <i-button type="primary" @click="exportTable" style="margin-left: 1em">导出</i-button>
      </div>
    </toolbar>
    <div class="table" v-if="dataTab == '列表'">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
    <div class="table" v-if="dataTab == '图表'">
      <onlineChart :flatData="flatData" :tableTimeList="tableTimeList" :timeType="timeType" :deviceType="deviceType"
        v-if="flatData && showCharts"></onlineChart>
      <div class="loading" v-else>
        <Spin></Spin>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;

  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 6);
  }
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";
import onlineChart from "./onlineChart.vue"
const moment = require('moment');
import * as XLSX from 'xlsx'
export default {
  name: "onlineData",
  props: {
    defaultDeviceType: {
      default: null
    }
  },
  data () {
    return {
      dataTab: "列表",
      timeType: "实时",
      // 表格
      table: {
        // 表格属性
        columns: [],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
      deviceType: 1,
      deviceTypeIds: {
        1: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 22],
        2: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 61],
        3: [86, 87, 88, 89, 90, 91, 92, 93, 94, 96, 100],
        5: [235, 236, 237, 251],
        6: [325, 326],
        7: [327, 328],
        8: [358],
        9: [360, 361],
        10: [359],
        11: [362]
      },
      // 查询
      search: {
        rtuCode: null,
        startDate: null,
        endDate: null
      },
      dateTimes: {
        dateRange: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null
      },
      columnsOptions: [
        {
          name: "颗粒物",
          code: "klw",
          unit: "mg/m³",
          sczIds: [16, 55, 93],
          zszIds: [17, 56, 94],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "二氧化硫",
          code: "eyhl",
          unit: "mg/m³",
          sczIds: [12, 51, 89],
          zszIds: [13, 52, 90],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "氮氧化物",
          code: "dyhw",
          unit: "mg/m³",
          sczIds: [14, 53, 91],
          zszIds: [15, 54, 92],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "氧含量",
          code: "yhl",
          unit: "%",
          sczIds: [22, 61, 100],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "烟气流速",
          code: "yqls",
          unit: "m/s",
          sczIds: [11, 50, 88],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "烟气温度",
          code: "yqwd",
          unit: "℃",
          sczIds: [],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        // {
        //     name: "烟气动压",
        //     code: "yqdy",
        //     unit: "kpa",
        //     sczIds: [],
        //     zszIds: [],
        //     pflIds: [],
        //     bzz: 0,
        //     deviceType: [1, 2, 3]
        // },
        {
          name: "烟气湿度",
          code: "yqsd",
          unit: "%",
          sczIds: [],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        // {
        //     name: "烟道截面积",
        //     code: "ydjmj",
        //     unit: "㎡",
        //     sczIds: [],
        //     zszIds: [],
        //     pflIds: [],
        //     bzz: 0,
        //     deviceType: [1, 2, 3]
        // },
        {
          name: "烟气压力",
          code: "yqyl",
          unit: "kpa",
          sczIds: [],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "烟气流量",
          code: "yqll",
          unit: "m³/h",
          sczIds: [],
          zszIds: [18, 57, 96],
          pflIds: [],
          bzz: 0,
          deviceType: [1, 2, 3]
        },
        {
          name: "污水处理后出水流量",
          code: "wsLl",
          unit: "m³/h",
          sczIds: [],
          zszIds: [251],
          pflIds: [],
          bzz: 0,
          deviceType: [5]
        },
        {
          name: "污水出水COD",
          code: "wsCod",
          unit: "mg/L",
          sczIds: [235],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [5]
        },
        {
          name: "污水出水氨氮",
          code: "wsAd",
          unit: "mg/L",
          sczIds: [236],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [5]
        },
        {
          name: "污水出水PH",
          code: "wsPh",
          unit: "",
          sczIds: [237],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [5]
        },
        {
          name: "B区雨排口南COD",
          code: "bNCod",
          unit: "mg/L",
          sczIds: [325],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [6]
        },
        {
          name: "B区雨排口南氨氮",
          code: "bNAd",
          unit: "mg/L",
          sczIds: [326],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [6]
        },
        {
          name: "B区雨排口北COD",
          code: "bBCod",
          unit: "mg/L",
          sczIds: [327],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [7]
        },
        {
          name: "B区雨排口北氨氮",
          code: "bBAd",
          unit: "mg/L",
          sczIds: [328],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [7]
        },
        {
          name: "锅炉窖井",
          code: "gljj",
          unit: "mg/L",
          sczIds: [358],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [8]
        },
        {
          name: "气化窖井COD",
          code: "qhjj1",
          unit: "mg/L",
          sczIds: [360],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [9]
        },
        {
          name: "气化窖井氨氮",
          code: "qhjj2",
          unit: "mg/L",
          sczIds: [361],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [9]
        },
        {
          name: "甲醇窖井COD",
          code: "jcjj",
          unit: "mg/L",
          sczIds: [359],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [10]
        },
        {
          name: "醋酸窖井COD",
          code: "csjj",
          unit: "mg/L",
          sczIds: [362],
          zszIds: [],
          pflIds: [],
          bzz: 0,
          deviceType: [11]
        }
      ],
      limitValueList: {
        klw: {
          1: 10,
          2: 10,
          3: 10,
          4: null,
          5: null,
          6: null,
          7: null
        },
        eyhl: {
          1: 35,
          2: 35,
          3: 35,
          4: null,
          5: null,
          6: null,
          7: null
        },
        dyhw: {
          1: 50,
          2: 50,
          3: 50,
          4: null,
          5: null,
          6: null,
          7: null
        },
        yhl: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null
        },
        yqls: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null
        },
        yqwd: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null
        },
        // yqdy: {
        //     1: null,
        //     2: null,
        //     3: null,
        //     4: null,
        //     5: null,
        //     6: null,
        //     7: null
        // },
        yqsd: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null
        },
        // ydjmj: {
        //     1: null,
        //     2: null,
        //     3: null,
        //     4: null,
        //     5: null,
        //     6: null,
        //     7: null
        // },
        yqyl: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null
        },
        yqll: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null
        },
        wsLl: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null
        },
        wsCod: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: 100,
          6: null,
          7: null
        },
        wsAd: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: 15,
          6: null,
          7: null
        },
        wsPh: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: "6-9",
          6: null,
          7: null
        },
        bNCod: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: 100,
          7: null
        },
        bNAd: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: 15,
          7: null
        },
        bBCod: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: 100
        },
        bBAd: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: 15
        },
        gljj: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null,
          8: null,
          9: null,
          10: null,
          11: null
        },
        qhjj1: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null,
          8: null,
          9: null,
          10: null,
          11: null
        },
        qhjj2: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
          6: null,
          7: null,
          8: null,
          9: null,
          10: null,
          11: null
        }
      },
      tableTimeList: [],
      flatData: [],
      showCharts: false,
      hourList: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
      deviceStatus: {
        "1#": {
          deviceId: [11, 22],
          status: true
        },
        "2#": {
          deviceId: [50, 61],
          status: true
        },
        "3#": {
          deviceId: [88],
          status: true
        }
      }
    };
  },
  components: {
    toolbar,
    onlineChart
  },
  created () {
    this.deviceType = this.defaultDeviceType || this.deviceType
    this.getOnlineOpitonData()
    this.getNowTime()
  },
  methods: {
    getOnlineOpitonData () {
      let nowTime = new Date().getTime()
      this.$api.Report.getLastOnlineStatus(
        {},
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            if (this.deviceStatus['1#'].deviceId[0] == item.siteDeviceId) {
              this.deviceStatus['1#'].status = item.siteDeviceAi >= 2
            }
            if (this.deviceStatus['1#'].deviceId[1] == item.siteDeviceId) {
              this.deviceStatus['1#'].status = item.siteDeviceAi <= 19
            }
            if (this.deviceStatus['2#'].deviceId[0] == item.siteDeviceId) {
              this.deviceStatus['2#'].status = item.siteDeviceAi >= 2
            }
            if (this.deviceStatus['2#'].deviceId[1] == item.siteDeviceId) {
              this.deviceStatus['2#'].status = item.siteDeviceAi <= 19
            }
            if (this.deviceStatus['3#'].deviceId[0] == item.siteDeviceId) {
              this.deviceStatus['3#'].status = item.siteDeviceAi >= 2
            }
            if (this.deviceStatus['3#'].deviceId[1] == item.siteDeviceId) {
              this.deviceStatus['3#'].status = item.siteDeviceAi <= 19
            }
          })
        }
      })
    },
    getNowTime () {
      // 获取当前时间
      const currentTime = new Date().getTime();
      if (this.timeType == "天") {
        let currentTimeStart = currentTime - 2 * 24 * 60 * 60 * 1000
        this.dateTimes.startDate = moment(currentTimeStart).format('YYYY-MM-DD')
        this.dateTimes.startTime = "00:00"
        this.dateTimes.endDate = moment(currentTime).format('YYYY-MM-DD')
        this.dateTimes.endTime = "23:59"
      } else if (this.timeType == "小时") {
        let currentTimeStart = currentTime - 0 * 24 * 60 * 60 * 1000
        this.dateTimes.startDate = moment(currentTimeStart).format('YYYY-MM-DD')
        this.dateTimes.startTime = "00"
        this.dateTimes.endDate = moment(currentTime).format('YYYY-MM-DD')
        this.dateTimes.endTime = moment(currentTime).format('HH').toString()
      } else if (this.timeType == "实时") {
        let currentTimeStart = currentTime - 3 * 60 * 60 * 1000
        this.dateTimes.startDate = moment(currentTimeStart).format('YYYY-MM-DD')
        this.dateTimes.startTime = moment(currentTimeStart).format('HH:mm')
        this.dateTimes.endDate = moment(currentTime).format('YYYY-MM-DD')
        this.dateTimes.endTime = moment(currentTime).format('HH:mm')
      }
      this.dateTimes.dateRange = [this.dateTimes.startDate, this.dateTimes.endDate]

      this.tableInit(); // 表格初始化
      window.addEventListener("resize", this.tableInit);
      this.getData();
    },
    getIdsCode (id) {
      //根据id获取该数据应属于什么大类，并获取code
      let code = ""
      this.columnsOptions.forEach(item => {
        if (item.sczIds.includes(id)) {
          code = item.code + "_scz"
        }
        if (item.zszIds.includes(id)) {
          code = item.code + "_zsz"
        }
        if (item.pflIds.includes(id)) {
          code = item.code + "_pfl"
        }
      })
      return code
    },
    filterData (list) {
      let res = []
      this.tableTimeList.forEach((minItem, minIndex) => {
        var obj = {
          time: minItem
        }
        this.columnsOptions.forEach((item, index) => {
          obj[item.code + "_scz"] = 0
          obj[item.code + "_zsz"] = 0
          // obj[item.code + "_bzz"] = this.limitValueList[item.code][this.deviceType] || 0
          obj[item.code + "_bzz"] = 0
          obj[item.code + "_pfl"] = 0
        })
        res.push(obj)
      })
      list.forEach(item => {
        //根据时间 获取列表index并根据code赋值
        let index = this.tableTimeList.indexOf(item.intTime.toString());
        let code = this.getIdsCode(item.id)
        if (index != -1 && res[index] && code) {
          res[index][code] = item.siteDeviceAi
          res[index][code.split("_")[0] + "_bzz"] = item.limitValue
          if (!res[index][code.split("_")[0] + "_bzz"] && code.split("_")[0] != "yqll") {
            res[index][code.split("_")[0] + "_bzz"] = item.siteDeviceAi
          }
        }
      })
      return res
    },
    initTimeSearch () {
      if (this.timeType == "天") {
        this.search.startDate = new Date(this.dateTimes.startDate + " 00:00").getTime()
        this.search.endDate = new Date(this.dateTimes.endDate + " 23:59").getTime()
      } else if (this.timeType == "小时") {
        this.search.startDate = new Date(this.dateTimes.startDate + " " + this.dateTimes.startTime + ":00").getTime()
        this.search.endDate = new Date(this.dateTimes.endDate + " " + this.dateTimes.endTime + ":59").getTime()
      } else if (this.timeType == "实时") {
        this.search.startDate = new Date(this.dateTimes.startDate + " " + this.dateTimes.startTime).getTime()
        this.search.endDate = new Date(this.dateTimes.endDate + " " + this.dateTimes.endTime).getTime()
      }
      //console.log("筛选时间起：" + moment(this.search.startDate).format('YYYYMMDDHHmm'))
      //console.log("筛选时间止：" + moment(this.search.endDate).format('YYYYMMDDHHmm'))
    },
    getTimeData (list) {
      if (this.timeType == "天" || this.timeType == "小时") {
        let resList = []
        this.tableTimeList.forEach(item => {
          let obj = {
            intTime: item,
            siteDeviceAi: 0
          }
          list.forEach(listItem => {
            if (listItem.intTime.toString().indexOf(item) != -1) {
              obj.siteDeviceAi += listItem.siteDeviceAi
              obj.id = listItem.id
              obj.name = listItem.name
              obj.limitValue = listItem.limitValue
              obj.unit = listItem.unit
            }
          })
          resList.push(obj)
        })
        resList.forEach(item => {
          if (this.timeType == "小时") {
            item.siteDeviceAi = (item.siteDeviceAi / (60)).toFixed(6)
          } else {
            item.siteDeviceAi = (item.siteDeviceAi / (24 * 60)).toFixed(6)
            // item.siteDeviceAi = (item.siteDeviceAi / (Math.floor((this.search.endDate - this.search.startDate) / (1000 * 60)))).toFixed(6)
          }
          // console.log(item.siteDeviceAi)
        })
        return resList
      } else if (this.timeType == "实时") {
        return list
      }
    },
    initTableColumns () {
      this.table.columns = []
      this.columnsOptions.forEach(item => {
        if (item.deviceType.includes(this.deviceType)) {
          let unit = this.getUnit(item.code)
          let obj = {
            title: item.name,
            align: "center",
            width: 100,
            children: [
              {
                title: unit ? "浓度(" + unit + ')' : '浓度',
                align: "center",
                width: 140,
                children: [
                  {
                    title: "实测值",
                    align: "center",
                    width: 100,
                    key: item.code + '_scz'
                  },
                  {
                    title: "折算值",
                    align: "center",
                    width: 100,
                    key: item.code + '_zsz',
                    render: (h, params) => {
                      if (params.row[item.code + '_zsz'] <= params.row[item.code + '_bzz']) {
                        return h("div", [
                          h(
                            "span",
                            {},
                            params.row[item.code + '_zsz']
                          )
                        ])
                      } else {
                        return h("div", {
                          style: {
                            display: "flex",
                            'align-items': "center",
                            gap: "5px"
                          }
                        }, [
                          h(
                            "span",
                            {
                              style: {
                                color: "red"
                              }
                            },
                            params.row[item.code + '_zsz']
                          ),
                          h(
                            "div",
                            {
                              style: {
                                width: "22px",
                                height: "22px",
                                border: "1px solid red",
                                textAlign: "center",
                                lineHeight: "22px"
                              }
                            },
                            "超"
                          )
                        ])
                      }
                    },
                  },
                ]
              },
              {
                title: unit ? "标准值(" + unit + ')' : '标准值',
                align: "center",
                width: 140,
                key: item.code + '_bzz',
              },
              {
                title: "排放量(千克)",
                align: "center",
                width: 120,
                key: item.code + '_pfl',
                render: (h, params) => {
                  if (item.code != 'yqll') {
                    return h("div", [
                      h(
                        "span",
                        {},
                        // (params.row[item.code + '_zsz'] * params.row.yqll_zsz / 1000000 / 60) == 0 ? 0 : 
                        // (params.row[item.code + '_zsz'] * params.row.yqll_zsz / 1000000 / 60).toFixed(6)
                        (params.row[item.code + '_zsz'] * params.row.yqll_zsz) == 0 ? 0 :
                          ((params.row[item.code + '_zsz'] * params.row.yqll_zsz) / 60000000).toFixed(6)
                      )
                    ])
                  } else {
                    return h(
                      "span",
                      {},
                      0
                    )
                  }
                },
              }
            ]
          }
          if (item.name == "污水处理后出水流量") {
            obj = {
              title: item.name,
              align: "center",
              children: [
                {
                  title: '出水流量(m3/h)',
                  align: "center",
                  key: item.code + '_zsz'
                }
              ]
            }
          } else if (item.name == "污水出水PH") {
            obj = {
              title: item.name,
              align: "center",
              children: [
                {
                  title: unit ? "浓度(" + unit + ')' : '浓度',
                  align: "center",
                  children: [
                    {
                      title: "检测值",
                      align: "center",
                      key: item.code + '_scz',
                      render: (h, params) => {
                        if (params.row[item.code + '_scz'] <= 9 && params.row[item.code + '_scz'] >= 6) {
                          return h("div", [
                            h(
                              "span",
                              {},
                              params.row[item.code + '_scz']
                            )
                          ])
                        } else {
                          return h("div", {
                            style: {
                              display: "flex",
                              'align-items': "center",
                              'justify-content': "center",
                              gap: "5px"
                            }
                          }, [
                            h(
                              "span",
                              {
                                style: {
                                  color: "red"
                                }
                              },
                              params.row[item.code + '_scz']
                            ),
                            h(
                              "div",
                              {
                                style: {
                                  width: "22px",
                                  height: "22px",
                                  border: "1px solid red",
                                  textAlign: "center",
                                  lineHeight: "22px"
                                }
                              },
                              "超"
                            )
                          ])
                        }
                      },
                    }
                  ]
                },
                {
                  title: unit ? "标准值(" + unit + ')' : '标准值',
                  align: "center",
                  key: item.code + '_bzz',
                }
              ]
            }
          } else if (item.name.indexOf("雨排口") != -1) {
            obj = {
              title: item.name,
              align: "center",
              children: [
                {
                  title: unit ? "浓度(" + unit + ')' : '浓度',
                  align: "center",
                  children: [
                    {
                      title: "检测值",
                      align: "center",
                      key: item.code + '_scz',
                      render: (h, params) => {
                        if (params.row[item.code + '_scz'] <= params.row[item.code + '_bzz']) {
                          return h("div", [
                            h(
                              "span",
                              {},
                              params.row[item.code + '_scz']
                            )
                          ])
                        } else {
                          return h("div", {
                            style: {
                              display: "flex",
                              'align-items': "center",
                              gap: "5px"
                            }
                          }, [
                            h(
                              "span",
                              {
                                style: {
                                  color: "red"
                                }
                              },
                              params.row[item.code + '_scz']
                            ),
                            h(
                              "div",
                              {
                                style: {
                                  width: "22px",
                                  height: "22px",
                                  border: "1px solid red",
                                  textAlign: "center",
                                  lineHeight: "22px"
                                }
                              },
                              "超"
                            )
                          ])
                        }
                      },
                    }
                  ]
                },
                {
                  title: unit ? "内控指标(" + unit + ')' : '内控指标',
                  align: "center",
                  key: item.code + '_bzz',
                }
              ]
            }
          } else if ((item.name.indexOf("COD") != -1 || item.name.indexOf("氨氮") != -1) && item.name.indexOf("窖井") == -1) {
            obj = {
              title: item.name,
              align: "center",
              width: 100,
              children: [
                {
                  title: unit ? "浓度(" + unit + ')' : '浓度',
                  align: "center",
                  width: 140,
                  children: [
                    {
                      title: "检测值",
                      align: "center",
                      key: item.code + '_scz',
                      render: (h, params) => {
                        if (params.row[item.code + '_scz'] <= params.row[item.code + '_bzz']) {
                          return h("div", [
                            h(
                              "span",
                              {},
                              params.row[item.code + '_scz']
                            )
                          ])
                        } else {
                          return h("div", {
                            style: {
                              display: "flex",
                              'align-items': "center",
                              gap: "5px"
                            }
                          }, [
                            h(
                              "span",
                              {
                                style: {
                                  color: "red"
                                }
                              },
                              params.row[item.code + '_scz']
                            ),
                            h(
                              "div",
                              {
                                style: {
                                  width: "22px",
                                  height: "22px",
                                  border: "1px solid red",
                                  textAlign: "center",
                                  lineHeight: "22px"
                                }
                              },
                              "超"
                            )
                          ])
                        }
                      },
                    }
                  ]
                },
                {
                  title: unit ? "标准值(" + unit + ')' : '标准值',
                  align: "center",
                  width: 140,
                  key: item.code + '_bzz',
                },
                {
                  title: "排放量(千克)",
                  align: "center",
                  width: 120,
                  key: item.code + '_pfl',
                  render: (h, params) => {
                    if (item.code != 'wsLl') {
                      return h("div", [
                        h(
                          "span",
                          {},
                          // (params.row[item.code + '_scz'] * params.row.wsLl_zsz / 1000000 / 60) == 0 ? 0 : 
                          // (params.row[item.code + '_scz'] * params.row.wsLl_zsz / 1000000 / 60).toFixed(6)
                          (params.row[item.code + '_scz'] * params.row.wsLl_zsz) == 0 ? 0 :
                            ((params.row[item.code + '_scz'] * params.row.wsLl_zsz) / 60000).toFixed(6)
                        )
                      ])
                    } else {
                      return h(
                        "span",
                        {},
                        0
                      )
                    }
                  },
                }
              ]
            }
          } else if (item.name.indexOf("窖井") != -1) {
            obj = {
              title: item.name,
              align: "center",
              children: [
                {
                  title: '实测值(mL/h)',
                  align: "center",
                  key: item.code + '_scz',
                  render: (h, params) => {
                    if (params.row[item.code + '_scz'] <= params.row[item.code + '_bzz']) {
                      return h("div", [
                        h(
                          "span",
                          {},
                          params.row[item.code + '_scz']
                        )
                      ])
                    } else {
                      return h("div", {
                        style: {
                          display: "flex",
                          'align-items': "center",
                          'justify-content': 'center',
                          gap: "5px"
                        }
                      }, [
                        h(
                          "span",
                          {
                            style: {
                              color: "red"
                            }
                          },
                          params.row[item.code + '_scz']
                        ),
                        h(
                          "div",
                          {
                            style: {
                              width: "22px",
                              height: "22px",
                              border: "1px solid red",
                              textAlign: "center",
                              lineHeight: "22px"
                            }
                          },
                          "超"
                        )
                      ])
                    }
                  },
                },
                {
                  title: '标准值(mL/h)',
                  align: "center",
                  key: item.code + '_bzz'
                },
              ]
            }
          } else if (item.name == "氧含量") {
            obj = {
              title: item.name,
              align: "center",
              width: 100,
              children: [
                {
                  title: unit ? "浓度(" + unit + ')' : '浓度',
                  align: "center",
                  width: 140,
                  children: [
                    {
                      title: "实测值",
                      align: "center",
                      width: 100,
                      key: item.code + '_scz'
                    },
                    {
                      title: "折算值",
                      align: "center",
                      width: 100,
                      key: item.code + '_zsz',
                      render: (h, params) => {
                        if (params.row[item.code + '_zsz'] <= params.row[item.code + '_bzz']) {
                          return h("div", [
                            h(
                              "span",
                              {},
                              params.row[item.code + '_zsz']
                            )
                          ])
                        } else {
                          return h("div", {
                            style: {
                              display: "flex",
                              'align-items': "center",
                              gap: "5px"
                            }
                          }, [
                            h(
                              "span",
                              {
                                style: {
                                  color: "red"
                                }
                              },
                              params.row[item.code + '_zsz']
                            ),
                            h(
                              "div",
                              {
                                style: {
                                  width: "22px",
                                  height: "22px",
                                  border: "1px solid red",
                                  textAlign: "center",
                                  lineHeight: "22px"
                                }
                              },
                              "超"
                            )
                          ])
                        }
                      },
                    },
                  ]
                },
                {
                  title: unit ? "标准值(" + unit + ')' : '标准值',
                  align: "center",
                  width: 140,
                  key: item.code + '_bzz',
                }
              ]
            }
          }
          this.table.columns.push(obj)
        }
      })
      this.table.columns.unshift({
        title: "时间",
        width: 150,
        align: 'center',
        key: "time",
        render: (h, params) => {
          return h("div", [
            h(
              "span",
              {},
              moment(params.row.time, 'YYYYMMDDHHmm').
                format(
                  this.timeType == "天" ? 'YYYY-MM-DD' :
                    this.timeType == "小时" ? 'YYYY-MM-DD HH时' :
                      'YYYY-MM-DD HH:mm'
                )
            )
          ])
        },
      })
      this.table.columns.unshift({
        type: 'index',
        width: 60,
        align: 'center'
      })
    },
    changePage () {
      this.table.loading = true;
      let flatData = this.flatData.filter(item => {
        return this.deviceTypeIds[this.deviceType].includes(item.id)
      })
      let tableData = this.filterData(flatData)
      tableData = tableData.reverse()
      //将最终数据进行分页
      this.table.data = tableData.filter((item, index) => {
        return index >= (this.table.pageCurrent - 1) * this.table.pageSize && index < this.table.pageCurrent * this.table.pageSize
      })
      // 获取成功
      this.table.loading = false;
    },
    changeDeviceType () {
      this.table.loading = true;
      this.table.pageCurrent = 1
      this.initTableColumns()
      let flatData = this.flatData.filter(item => {
        return this.deviceTypeIds[this.deviceType].includes(item.id)
      })
      let tableData = this.filterData(flatData)
      tableData = tableData.reverse()
      //将最终数据进行分页
      this.table.data = tableData.filter((item, index) => {
        return index >= (this.table.pageCurrent - 1) * this.table.pageSize && index < this.table.pageCurrent * this.table.pageSize
      })
      // 获取成功
      this.table.loading = false;
      this.showCharts = false
      setTimeout(() => {
        this.showCharts = true
      }, 10)
    },
    getData () {
      this.initTimeSearch()
      this.initTableColumns()
      this.table.loading = true;
      this.showCharts = false
      this.$api.Report.getOnlineList(
        { content: this.search },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // console.log(res)
          // 根据时间类型获取数据总数和生成时间序列
          if (this.timeType == "天") {
            this.table.total = Math.floor((this.search.endDate - this.search.startDate) / (1000 * 60 * 60 * 24))
            this.tableTimeList = []
            for (let i = 0; i <= this.table.total; i++) {
              const currentTime = new Date(this.search.startDate + i * 1000 * 60 * 60 * 24); // 加上分钟差异的毫秒数
              this.tableTimeList.push(moment(currentTime).format('YYYYMMDD')); // 格式为年月日时分
            }
          } else if (this.timeType == "小时") {
            this.table.total = Math.floor((this.search.endDate - this.search.startDate) / (1000 * 60 * 60))
            this.tableTimeList = []
            for (let i = 0; i <= this.table.total; i++) {
              const currentTime = new Date(this.search.startDate + i * 1000 * 60 * 60); // 加上分钟差异的毫秒数
              this.tableTimeList.push(moment(currentTime).format('YYYYMMDDHH')); // 格式为年月日时分
            }
          } else if (this.timeType == "实时") {
            this.table.total = Math.floor((this.search.endDate - this.search.startDate) / (1000 * 60))
            this.tableTimeList = []
            for (let i = 0; i <= this.table.total; i++) {
              const currentTime = new Date(this.search.startDate + i * 1000 * 60); // 加上分钟差异的毫秒数
              this.tableTimeList.push(moment(currentTime).format('YYYYMMDDHHmm')); // 格式为年月日时分
            }
          }
          res.data.forEach(item => {
            if (item.extRecordStatisticList.length) {
              item.extRecordStatisticList = this.getTimeData(item.extRecordStatisticList)
            }
          })
          //将数据扁平化
          this.flatData = []
          res.data.forEach(item => {
            item.extRecordStatisticList.forEach(extItem => {
              extItem = {
                ...extItem,
                name: item.name,
                unit: item.unit,
                id: item.id,
                limitValue: item.limitValue || null
              }
              this.flatData.push(extItem)
            })
          })
          let flatData = this.flatData.filter(item => {
            return this.deviceTypeIds[this.deviceType].includes(item.id)
          })
          let tableData = this.filterData(flatData)
          tableData = tableData.reverse()
          //将最终数据进行分页
          this.table.data = tableData.filter((item, index) => {
            return index >= (this.table.pageCurrent - 1) * this.table.pageSize && index < this.table.pageCurrent * this.table.pageSize
          })
          // 获取成功
          this.table.loading = false;
          this.$Message.success("加载完成");
          this.showCharts = true
        } else {
          this.$Notice.warning({
            title: "获取数据失败",
            desc: res.message || "请联系管理员"
          });
          // this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    //导出
    exportTable () {
      if (this.table.loading) {
        this.$Message.warning("数据加载中");
        return
      }
      let items = []
      let h1 = []
      let h2 = []
      let h3 = []
      this.table.columns.forEach(item => {
        if (item.type != "index" && item.title && item.title != "时间") {
          if (this.deviceType != 5 && this.deviceType != 6 && this.deviceType != 7 && this.deviceType != 8 && this.deviceType != 9 && this.deviceType != 10 && this.deviceType != 11) {
            if (item.title == "氧含量") {
              h1.push(item.title)
              h1.push("")
              h1.push("")
            } else {
              h1.push(item.title)
              h1.push("")
              h1.push("")
              h1.push("")
            }
          } else if (this.deviceType == 5) {
            if (item.title == "污水处理后出水流量") {
              h1.push(item.title)
            } else if (item.title == "污水出水PH") {
              h1.push(item.title)
              h1.push("")
            } else {
              h1.push(item.title)
              h1.push("")
              h1.push("")
            }
          } else if (this.deviceType == 6 || this.deviceType == 7) {
            h1.push(item.title)
            h1.push("")
          } else if (this.deviceType == 8 || this.deviceType == 9 || this.deviceType == 10 || this.deviceType == 11) {
            h1.push(item.title)
            h1.push("")
          }


          if (this.deviceType != 5 && this.deviceType != 6 && this.deviceType != 7 && this.deviceType != 8 && this.deviceType != 9 && this.deviceType != 10 && this.deviceType != 11) {
            if (item.title == "氧含量") {
              h3.push("实测值")
              h3.push("折算值")
              h3.push("")
            } else {
              h3.push("实测值")
              h3.push("折算值")
              h3.push("")
              h3.push("")
            }
          } else if (this.deviceType == 5) {
            if (item.title == "污水处理后出水流量") {
              h3.push("")
            } else if (item.title == "污水出水PH") {
              h3.push("检测值")
              h3.push("")
            } else {
              h3.push("检测值")
              h3.push("")
              h3.push("")
            }
          } else if (this.deviceType == 6 || this.deviceType == 7) {
            h3.push("检测值")
            h3.push("")
          }
        }
        if (item.children) {
          item.children.forEach(child => {
            if (this.deviceType != 5 && this.deviceType != 6 && this.deviceType != 7) {
              if (child.title.indexOf("浓度") != -1) {
                h2.push(child.title)
                h2.push("")
              } else {
                h2.push(child.title)
              }
            } else {
              h2.push(child.title)
            }
          })
        }
      })
      h1.unshift("时间")
      h2.unshift("时间")
      if (this.deviceType != 8 && this.deviceType != 9 && this.deviceType != 10 && this.deviceType != 11) {
        h3.unshift("时间")
      }
      if (h1.length) {
        items.push(h1)
      }
      if (h2.length) {
        items.push(h2)
      }
      if (h3.length) {
        items.push(h3)
      }
      let flatData = this.flatData.filter(item => {
        return this.deviceTypeIds[this.deviceType].includes(item.id)
      })
      let fullTableData = this.filterData(flatData)
      fullTableData = fullTableData.reverse()
      fullTableData.forEach(item => {
        let time = moment(item.time, 'YYYYMMDDHHmm').format(
          this.timeType == "天" ? 'YYYY-MM-DD' :
            this.timeType == "小时" ? 'YYYY-MM-DD HH时' :
              'YYYY-MM-DD HH:mm'
        )
        if (this.deviceType != 5 && this.deviceType != 6 && this.deviceType != 7 && this.deviceType != 8 && this.deviceType != 9 && this.deviceType != 10 && this.deviceType != 11) {
          let obj = [time]
          this.columnsOptions.forEach(coItem => {
            if (coItem.deviceType.includes(this.deviceType) && !coItem.deviceType.includes(5) && !coItem.deviceType.includes(6) && !coItem.deviceType.includes(7)) {
              if (coItem.name == "氧含量") {
                obj.push(item[coItem.code + "_scz"])
                obj.push(item[coItem.code + "_zsz"])
                obj.push(item[coItem.code + "_bzz"])
              } else {
                obj.push(item[coItem.code + "_scz"])
                obj.push(item[coItem.code + "_zsz"])
                obj.push(item[coItem.code + "_bzz"])
                obj.push(item[coItem.code + "_pfl"])
              }
            }
          })
          items.push(obj)
        } else if (this.deviceType == 5) {
          let obj = [time]
          this.columnsOptions.forEach(coItem => {
            if (coItem.deviceType.includes(5)) {
              if (coItem.name == "污水处理后出水流量") {
                obj.push(item[coItem.code + "_scz"])
              } else if (coItem.name == "污水出水PH") {
                obj.push(item[coItem.code + "_scz"])
                obj.push(item[coItem.code + "_bzz"])
              } else {
                obj.push(item[coItem.code + "_scz"])
                obj.push(item[coItem.code + "_bzz"])
                obj.push(item[coItem.code + "_pfl"])
              }
            }
          })
          items.push(obj)
        } else if (this.deviceType == 6) {
          let obj = [time]
          this.columnsOptions.forEach(coItem => {
            if (coItem.deviceType.includes(6)) {
              obj.push(item[coItem.code + "_scz"])
              obj.push(item[coItem.code + "_bzz"])
            }
          })
          items.push(obj)
        } else if (this.deviceType == 7) {
          let obj = [time]
          this.columnsOptions.forEach(coItem => {
            if (coItem.deviceType.includes(7)) {
              obj.push(item[coItem.code + "_scz"])
              obj.push(item[coItem.code + "_bzz"])
            }
          })
          items.push(obj)
        } else if (this.deviceType == 8 || this.deviceType == 9 || this.deviceType == 10 || this.deviceType == 11) {
          let obj = [time]
          this.columnsOptions.forEach(coItem => {
            if (coItem.deviceType.includes(this.deviceType)) {
              obj.push(item[coItem.code + "_scz"])
              obj.push(item[coItem.code + "_bzz"])
            }
          })
          items.push(obj)
        }
        // && this.deviceType != 8  && this.deviceType != 9  && this.deviceType != 10  && this.deviceType != 11
      })
      // 创建一个工作簿
      const wb = XLSX.utils.book_new();
      // 创建一个工作表
      const ws = XLSX.utils.aoa_to_sheet(items);

      if (this.deviceType != 5 && this.deviceType != 6 && this.deviceType != 7 && this.deviceType != 8 && this.deviceType != 9 && this.deviceType != 10 && this.deviceType != 11) {

        ws['!merges'] = [
          //合并时间单元格
          { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
          //合并大类单元格
          { s: { r: 0, c: 1 }, e: { r: 0, c: 4 } },
          { s: { r: 0, c: 5 }, e: { r: 0, c: 8 } },
          { s: { r: 0, c: 9 }, e: { r: 0, c: 12 } },
          { s: { r: 0, c: 13 }, e: { r: 0, c: 15 } },
          { s: { r: 0, c: 16 }, e: { r: 0, c: 19 } },
          { s: { r: 0, c: 20 }, e: { r: 0, c: 23 } },
          { s: { r: 0, c: 24 }, e: { r: 0, c: 27 } },
          { s: { r: 0, c: 28 }, e: { r: 0, c: 31 } },
          { s: { r: 0, c: 32 }, e: { r: 0, c: 35 } },
          // { s: { r: 0, c: 37 }, e: { r: 0, c: 40 } },
          // { s: { r: 0, c: 41 }, e: { r: 0, c: 44 } },
          //合并浓度单元格
          { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } },
          { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } },
          { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } },
          { s: { r: 1, c: 13 }, e: { r: 1, c: 14 } },
          { s: { r: 1, c: 16 }, e: { r: 1, c: 17 } },
          { s: { r: 1, c: 20 }, e: { r: 1, c: 21 } },
          { s: { r: 1, c: 24 }, e: { r: 1, c: 25 } },
          { s: { r: 1, c: 28 }, e: { r: 1, c: 29 } },
          { s: { r: 1, c: 32 }, e: { r: 1, c: 33 } },
          // { s: { r: 1, c: 37 }, e: { r: 1, c: 38 } },
          // { s: { r: 1, c: 41 }, e: { r: 1, c: 42 } },
          //合并标准值/排放量
          { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } },
          { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },
          { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
          { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
          { s: { r: 1, c: 11 }, e: { r: 2, c: 11 } },
          { s: { r: 1, c: 12 }, e: { r: 2, c: 12 } },
          { s: { r: 1, c: 15 }, e: { r: 2, c: 15 } },
          // { s: { r: 1, c: 16 }, e: { r: 2, c: 16 } },
          { s: { r: 1, c: 18 }, e: { r: 2, c: 18 } },
          { s: { r: 1, c: 19 }, e: { r: 2, c: 19 } },
          { s: { r: 1, c: 22 }, e: { r: 2, c: 22 } },
          { s: { r: 1, c: 23 }, e: { r: 2, c: 23 } },
          { s: { r: 1, c: 26 }, e: { r: 2, c: 26 } },
          { s: { r: 1, c: 27 }, e: { r: 2, c: 27 } },
          { s: { r: 1, c: 30 }, e: { r: 2, c: 30 } },
          { s: { r: 1, c: 31 }, e: { r: 2, c: 31 } },
          { s: { r: 1, c: 34 }, e: { r: 2, c: 34 } },
          { s: { r: 1, c: 35 }, e: { r: 2, c: 35 } },
          { s: { r: 1, c: 38 }, e: { r: 2, c: 38 } },
          { s: { r: 1, c: 39 }, e: { r: 2, c: 39 } },
          // { s: { r: 1, c: 43 }, e: { r: 2, c: 43 } },
          // { s: { r: 1, c: 44 }, e: { r: 2, c: 44 } },
        ];
      } else if (this.deviceType == 5) {
        ws['!merges'] = [
          //合并时间单元格
          { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
          //合并大类单元格
          { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } },
          { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } },
          { s: { r: 0, c: 8 }, e: { r: 0, c: 9 } },
          // //合并标准值/排放量
          { s: { r: 1, c: 1 }, e: { r: 2, c: 1 } },
          { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } },
          { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },
          { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
          { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
          { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } }
        ];
      } else if (this.deviceType == 6 || this.deviceType == 7) {
        ws['!merges'] = [
          //合并时间单元格
          { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
          //合并大类单元格
          { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
          { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
          // //合并标准值
          { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } },
          { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },
        ];
      } else if (this.deviceType == 8 || this.deviceType == 10 || this.deviceType == 11) {
        ws['!merges'] = [
          //合并时间单元格
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          //合并大类单元格
          { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
        ];
      } else if (this.deviceType == 9) {
        ws['!merges'] = [
          //合并时间单元格
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
          //合并大类单元格
          { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
          { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
        ];
      }
      ws['!cols'] = [{ wpx: 100 }];
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      // 将工作簿写入文件
      XLSX.writeFile(wb, 'output.xlsx');
    },
    // 搜索
    searchFunc () {
      this.getData();
    },
    pageCurrentChange (num) {
      // 页码跳转
      this.table.pageCurrent = num;
      // this.getData();
      this.changePage()
    },
    pageSizeChange (num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.changePage()
    },
    // 选择时间
    dateSelect (date) {
      this.dateTimes.startDate = date[0];
      this.dateTimes.endDate = date[1];
    },
    getUnit (code) {
      let unit = ""
      this.columnsOptions.forEach(item => {
        if (item.code == code) {
          unit = item.unit
        }
      })
      return unit
    },
    // 表格高度计算
    tableInit () {
      let headerH = emComputed(14.5); // header高度7em加操作栏5.5em转换px， 2em的上下边距分页组件
      this.table.maxHeight = window.innerHeight - headerH - 32; // 32px的分页组件高度
      if (this.$route.path != "/chome/reportTable") {
        window.removeEventListener("resize", this.tableInit);
      }
    },
  },
};
</script>